import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { SP111AutoTracking } from '@EcamModel/model/SP111AutoTracking';
import { SP111Basic } from '@EcamModel/model/SP111Basic';
import { SP111CameraDayNight } from '@EcamModel/model/SP111CameraDayNight';
import { SP111Camera } from '@EcamModel/model/SP111Cameras';
import { SP111CameraSetting } from '@EcamModel/model/SP111CameraSetting';
import { SP111EventMotionDetection } from '@EcamModel/model/SP111EventMotionDetection';
import { SP111EventSnap } from '@EcamModel/model/SP111EventSnap';
import { SP111Limit } from '@EcamModel/model/SP111Limit';
import { SP111RecordSetting } from '@EcamModel/model/SP111RecordSetting';
import { SP111ScheduledTask } from '@EcamModel/model/SP111ScheduledTask';
import { SP111SnapshotSetting } from '@EcamModel/model/SP111SnapshotSetting';
import { SP111StorageSetting } from '@EcamModel/model/SP111StorageSetting';
import { SP111SysDateTime } from '@EcamModel/model/SP111SysDateTime';
import { SP111SysInfo } from '@EcamModel/model/SP111SysInfo';
import { SP111VideoGeneral } from '@EcamModel/model/SP111VideoGeneral';
import { AxiosInstance } from 'axios';
import {
    ISendActionGet
} from '../IPTZCamConfigureRequestHttpController';
import { ISP111ConfigureHttpController } from '../ISP111ConfigureHttpController';

export class SP111ConfigureRequestHttpController
    extends BaseHttpController<SP111Camera>
    implements ISP111ConfigureHttpController {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'sp111-configure-request', client);
    }

    async getPhotoSnapShot(props: ISendActionGet): Promise<string> {
        return await this.doPost({ path: 'get-photo-snapshot', body: props }).then((res) => res.data);
    }

    async getSP111SystemInfo(props: ISendActionGet): Promise<SP111SysInfo> {
        return await this.doPost({ path: 'get-sp111-sys-info', body: props }).then((res) => res.data);
    }

    async getSP111Basic(props: ISendActionGet): Promise<SP111Basic> {
        return await this.doPost({ path: 'get-sp111-basic', body: props }).then((res) => res.data);
    }

    async getSP111Limit(props: ISendActionGet): Promise<SP111Limit> {
        return await this.doPost({ path: 'get-sp111-limit', body: props }).then((res) => res.data);
    }

    async getSP111RecordSetting(props: ISendActionGet): Promise<SP111RecordSetting> {
        return await this.doPost({ path: 'get-sp111-record-setting', body: props }).then((res) => res.data);
    }

    async getSP111AutoTracking(props: ISendActionGet): Promise<SP111AutoTracking> {
        return await this.doPost({ path: 'get-sp111-auto-tracking', body: props }).then((res) => res.data);
    }

    async getSP111ScheduledTask(props: ISendActionGet): Promise<SP111ScheduledTask> {
        return await this.doPost({ path: 'get-sp111-scheduled-task', body: props }).then((res) => res.data);
    }

    async getSP111CameraDayNight(props: ISendActionGet): Promise<SP111CameraDayNight> {
        return await this.doPost({ path: 'get-sp111-camera-day-night', body: props }).then((res) => res.data);
    }

    async getSP111VideoGeneral(props: ISendActionGet): Promise<SP111VideoGeneral> {
        return await this.doPost({ path: 'get-sp111-video-general', body: props }).then((res) => res.data);
    }

    async getSP111StorageSetting(props: ISendActionGet): Promise<SP111StorageSetting> {
        return await this.doPost({ path: 'get-sp111-storage-setting', body: props }).then((res) => res.data);
    }

    async getSP111SnapShotSetting(props: ISendActionGet): Promise<SP111SnapshotSetting> {
        return await this.doPost({ path: 'get-sp111-snapshot-setting', body: props }).then((res) => res.data);
    }

    async getSP111EventSnap(props: ISendActionGet): Promise<SP111EventSnap> {
        return await this.doPost({ path: 'get-sp111-event-snap', body: props }).then((res) => res.data);
    }

    async getSP111EventMotionDetection(props: ISendActionGet): Promise<SP111EventMotionDetection> {
        return await this.doPost({ path: 'get-sp111-event-motion-detection', body: props }).then((res) => res.data);
    }

    async getSP111CameraSetting(props: ISendActionGet): Promise<SP111CameraSetting> {
        return await this.doPost({ path: 'get-sp111-camera-setting', body: props }).then((res) => res.data);
    }

    async getSP111SysDateTime(props: ISendActionGet): Promise<SP111SysDateTime> {
        return await this.doPost({ path: 'get-sp111-sys-date-time', body: props }).then((res) => res.data);
    }
}
